import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=4704a1b3&scoped=true&lang=html&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=4704a1b3&lang=stylus&scoped=true&"
import style1 from "./loading.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704a1b3",
  null
  
)

export default component.exports